(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire46df"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire46df"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $a8ffe04fad4cfd25$exports = {};
$parcel$extendImportMap({
    "frOE0": "play.c1d3b9ae.svg",
    "ad51v": "pause.433e79c9.svg"
});

/**
 * @param {HTMLVideoElement} element
 */ function $3cfeed1fccbdf967$export$6c96167f46662e38(element) {
    if (!(element instanceof HTMLVideoElement)) return;
    let reducedMotionNoPref = window.matchMedia("(prefers-reduced-motion: no-preference)");
    if (reducedMotionNoPref.matches) play();
    function play() {
        try {
            element.play();
        } catch (error) {
        // no catch
        }
    }
    reducedMotionNoPref.addEventListener("change", ()=>{
        reducedMotionNoPref.matches ? play() : element.pause();
    });
}


var $39b3979787198c97$exports = {};
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    $39b3979787198c97$exports = factory();
})($39b3979787198c97$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});


/**
 * @param {Document|HTMLElement} root
 * @param {string} selector
 */ function $bf76b386537e82d7$export$dcd0d083aa86c355(root = document, selector) {
    return Array.from(root.querySelectorAll(selector));
}
function $bf76b386537e82d7$export$c8a8987d4410bf2d(tag, attributes = {}) {
    let element = document.createElement(tag);
    Object.entries(attributes).forEach(([key, value])=>{
        element.setAttribute(key, value);
    });
    return element;
}


function $14e72c11e5d59e2b$export$caec2af78bcc877f(element) {
    let cookieName = element.dataset.id;
    let controls = (0, $bf76b386537e82d7$export$dcd0d083aa86c355)(element, ".js-alert-dismiss");
    controls.forEach((elem)=>{
        elem.addEventListener("click", controlClick);
    });
    /** @type Cookies.CookieAttributes */ let cookieOptions = {
        sameSite: "None",
        secure: true
    };
    if (element.dataset.expiry) cookieOptions.expires = new Date(element.dataset.expiry);
    /**
   * @param {MouseEvent} event
   */ function controlClick(event) {
        event.preventDefault();
        if (cookieName) (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).set(cookieName, "1", cookieOptions);
        element.remove();
    }
}


let $0680554f6bbebb99$var$started = false;
let $0680554f6bbebb99$var$connectedComponents = [];
let $0680554f6bbebb99$var$registeredComponents = {};
function $0680554f6bbebb99$export$86fbec116b87613f(element = document.documentElement) {
    let observer = new MutationObserver((mutations)=>processMutations(mutations));
    function start() {
        if ($0680554f6bbebb99$var$started) return;
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
        observe();
        createComponents(element);
        document.removeEventListener("DOMContentLoaded", start);
        $0680554f6bbebb99$var$started = true;
    }
    /**
   * @param {MutationRecord[]} mutations
   */ function processMutations(mutations) {
        unobserve();
        mutations.forEach((record)=>{
            Array.from(record.addedNodes).filter(isHTMLELement).forEach((element)=>createComponents(element));
            Array.from(record.removedNodes).filter(isHTMLELement).forEach((element)=>removeComponents(element));
        });
        observe();
    }
    function observe() {
        observer.observe(element, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                "data-component"
            ]
        });
    }
    function unobserve() {
        observer.takeRecords();
        observer.disconnect();
    }
    /**
   * @param {string} name
   * @param component
   */ function register(name, component) {
        if (isComponentRegistered(name)) return;
        $0680554f6bbebb99$var$registeredComponents[name] = component;
        if ($0680554f6bbebb99$var$started) {
            unobserve();
            createComponents(element, name);
            observe();
        }
    }
    /**
   * @param {HTMLElement} element
   * @param {string} name
   */ function createComponents(element, name) {
        getElements(element).map((element)=>getComponentNamesFromDataAttribue(element).filter((n)=>name === undefined || n === name).forEach((name)=>createComponent(element, name)));
    }
    /**
   * @param {HTMLElement} element
   * @param {string} name
   */ function removeComponents(element, name) {
        getElements(element).map((element)=>getComponentNamesFromDataAttribue(element).filter((n)=>name === undefined || n === name).forEach((name)=>removeComponent(element, name)));
    }
    /**
   * @param {HTMLElement} element
   * @param {string} name
   */ function createComponent(element, name) {
        if (!isComponentRegistered(name)) return;
        (getEntry(element) || createEntry(element)).add(name);
    }
    /**
   * @param {HTMLElement} element
   * @param {string} name
   */ function removeComponent(element, name) {
        let index = getEntryIndex(element);
        if (index < 0) return;
        $0680554f6bbebb99$var$connectedComponents[index].remove(name);
        $0680554f6bbebb99$var$connectedComponents.splice(index, 1);
    }
    function getElements(parent) {
        return [
            parent,
            ...parent.querySelectorAll("[data-component]")
        ];
    }
    /**
   * @param value
   */ function isHTMLELement(value) {
        return value instanceof HTMLElement;
    }
    /**
   * @param {HTMLElement} element
   * @return {number}
   */ function getEntryIndex(element) {
        return $0680554f6bbebb99$var$connectedComponents.findIndex((entry)=>entry.element === element);
    }
    /**
   * @param {HTMLElement} element
   * @return {undefined|*}
   */ function getEntry(element) {
        let index = getEntryIndex(element);
        if (index < 0) return undefined;
        return $0680554f6bbebb99$var$connectedComponents[index];
    }
    /**
   * @param {Element} element
   * @return {{add(string): void, components: *[], getIndex(string): *|number, get(string): *|undefined, has(string): boolean, remove(string): void, element: Element}|number|*|undefined|boolean}
   */ function createEntry(element) {
        let entry = {
            element: element,
            components: [],
            /**
       * @param {string} name
       */ get (name) {
                let i = this.getIndex(name);
                return i > -1 ? this.components[i] : undefined;
            },
            /**
       * @param {string} name
       */ getIndex (name) {
                return this.components.findIndex((c)=>c.name === name);
            },
            /**
       * @param {string} name
       */ has (name) {
                return this.getIndex(name) > -1;
            },
            /**
       * @param {string} name
       */ add (name) {
                if (this.has(name)) return;
                let component = $0680554f6bbebb99$var$registeredComponents[name](element);
                if (typeof component?.connect === "function") component.connect();
                this.components.push({
                    name: name,
                    component: component
                });
            },
            /**
       * @param {string} name
       */ remove (name) {
                let index = this.getIndex(name);
                if (!(index > -1)) return;
                let component = this.components[index];
                if (typeof component?.disconnect === "function") component.disconnect();
                this.components.splice(index, 1);
            }
        };
        $0680554f6bbebb99$var$connectedComponents.push(entry);
        return entry;
    }
    /**
   * @param {string} name
   * @return {boolean}
   */ function isComponentRegistered(name) {
        return Object.prototype.hasOwnProperty.call($0680554f6bbebb99$var$registeredComponents, name);
    }
    /**
   * @param {HTMLElement} element
   * @return {string[]|*[]}
   */ function getComponentNamesFromDataAttribue(element) {
        if (!(element instanceof HTMLElement) || !element.hasAttribute("data-component")) return [];
        return element.dataset.component.split(/\s+/);
    }
    return {
        start: start,
        register: register,
        connectedComponents: $0680554f6bbebb99$var$connectedComponents,
        registeredComponents: $0680554f6bbebb99$var$registeredComponents
    };
}


/**
 * Clamps a number between a lower and upper value.
 *
 * @param {number} rawValue
 * @param {number|undefined|null} lower
 * @param {number|undefined|null} upper
 * @return {number}
 */ function $d2962d03d480f635$export$7d15b64cf5a3a4c4(rawValue, lower, upper) {
    let value = rawValue;
    if (upper !== undefined && upper !== null) value = value <= upper ? value : upper;
    if (lower !== undefined && lower !== null) value = value >= lower ? value : lower;
    return value;
}
function $d2962d03d480f635$export$a4d69fb5f2026c35(value, lower, upper, inclusive = true) {
    if (inclusive) return value >= lower && value <= upper;
    return value > lower && value < upper;
}


/**
 * @typedef {Object} Options
 * @property {string} prevSelector
 * @property {string} NextSelector
 * @property {string} trackSelector
 * @property {string} stepsSelector
 */ /**
 * @typedef {Object} ItemObject
 * @property {number} index
 * @property {Function} scrollTo
 * @property {HTMLElement} element
 * @property {{ size: number; start: number; end: number }} rect
 */ /** @type {Options} */ const $e18e62e0f1712f3a$var$defaultOptions = {
    prevSelector: ".js-carousel-prev",
    nextSelector: ".js-carousel-next",
    trackSelector: ".js-carousel-items",
    stepsSelector: ".js-carousel-steps"
};
function $e18e62e0f1712f3a$export$144901db2ea8e967(rootElement, options = {}) {
    let config = {
        ...$e18e62e0f1712f3a$var$defaultOptions,
        ...options
    };
    /** @type {ItemObject[]} */ let items;
    /** @type {ItemObject} */ let currentItem;
    let steps = [];
    let activeStep = 0;
    let scrollRoot = rootElement.querySelector(config.trackSelector);
    if (scrollRoot === null) return;
    scrollRoot.addEventListener("scroll", scrollRootScroll);
    let prevControl = rootElement.querySelector(config.prevSelector);
    let nextControl = rootElement.querySelector(config.nextSelector);
    let paginationContainer = rootElement.querySelector(config.stepsSelector);
    let controlAlignmentRef = rootElement.querySelector(".js-slider-prev-next-alignment-ref");
    scrollRoot.setAttribute("tabindex", "0");
    prevControl?.addEventListener("click", ()=>goToRelative(-1));
    nextControl?.addEventListener("click", ()=>goToRelative(1));
    items = Array.from(scrollRoot.children).map((element, index)=>Item(element, index));
    window.addEventListener("DOMContentLoaded", ()=>{
        items.forEach((item)=>item.calculateRect());
        currentItem = getClosestItem(scrollRoot.scrollLeft);
        createPagination();
        scrollRootScroll();
        positionPrevNext();
    });
    window.addEventListener("resize", ()=>{
        items.forEach((item)=>item.calculateRect());
        createPagination();
        setActiveStep();
    });
    rootElement.addEventListener("keydown", elementKeydown);
    /**
   * @param {number} value
   */ function getItem(value) {
        return items[value] || null;
    }
    /**
   * @param {number} amount
   */ function goToRelative(amount) {
        let index = (0, $d2962d03d480f635$export$7d15b64cf5a3a4c4)(currentItem.index + amount, 0, items.length - 1);
        currentItem = getItem(index);
        currentItem.scrollTo();
    }
    /**
   * @param {number} position
   * @return {*}
   */ function getClosestItem(position) {
        let index = 0;
        /** @type {number|undefined} */ let minDelta;
        for(let i = 0; i < items.length; i++){
            let delta = Math.abs(position - items[i].rect.start);
            if (minDelta !== undefined && delta > minDelta) continue;
            index = i;
            minDelta = delta;
        }
        return getItem(index);
    }
    function scrollRootScroll() {
        let scrollMin = 0;
        let scrollMax = scrollRoot.scrollWidth - scrollRoot.clientWidth;
        let position = scrollRoot.scrollLeft;
        let scrollable = scrollRoot.scrollWidth > scrollRoot.clientWidth;
        rootElement.classList.toggle("is-scrollable", scrollable);
        rootElement.classList.toggle("is-not-scrollable", !scrollable);
        prevControl?.classList.toggle("hidden", !scrollable);
        nextControl?.classList.toggle("hidden", !scrollable);
        paginationContainer?.classList.toggle("hidden", !scrollable);
        prevControl?.classList.toggle("is-disabled", position <= scrollMin);
        nextControl?.classList.toggle("is-disabled", position >= scrollMax);
        currentItem = getClosestItem(position);
        setActiveStep();
    }
    function positionPrevNext() {
        if (!controlAlignmentRef) return;
        let rootRect = rootElement.getBoundingClientRect();
        let referenceRect = controlAlignmentRef.getBoundingClientRect();
        let top = referenceRect.top - rootRect.top + referenceRect.height / 2;
        prevControl.style.top = `${top}px`;
        nextControl.style.top = `${top}px`;
    }
    /**
   * @param {KeyboardEvent} event
   */ function elementKeydown(event) {
        let { key: key } = event;
        switch(key){
            case "ArrowLeft":
                goToRelative(-1);
                event.preventDefault();
                break;
            case "ArrowRight":
                goToRelative(1);
                event.preventDefault();
                break;
            default:
        }
    }
    function createPagination() {
        if (!paginationContainer) return;
        let count = 0;
        let runningWidth = 0;
        let viewportWidth = scrollRoot.clientWidth;
        let referenceWidth = viewportWidth;
        for(let i = 0; i < items.length; i++){
            let { rect: rect } = items[i];
            runningWidth += rect.end - rect.start;
            if (runningWidth > referenceWidth) {
                count++;
                referenceWidth += viewportWidth;
            }
        }
        steps = [];
        paginationContainer.innerHTML = "";
        for(let i = 0; i <= count; i++){
            let a = document.createElement("span");
            paginationContainer.appendChild(a);
            a.classList.add("c-carousel__page");
            steps.push(a);
            a.addEventListener("click", ()=>{
                scrollRoot.scrollTo({
                    left: i * viewportWidth,
                    behavior: getScrollBehaviour()
                });
            });
        }
    }
    function setActiveStep() {
        let t = 0;
        if (steps.length === 0) return;
        let { scrollLeft: scrollLeft, clientWidth: clientWidth } = scrollRoot;
        for(let i = 0; i < steps.length; i++){
            // The -1 is to account for rounding errors in scrollLeft and clientWidth.
            // In testing this accounts for instances when scrollLeft is rounded up or down.
            let start = i * clientWidth - 1;
            let end = start + clientWidth - 1;
            if ((0, $d2962d03d480f635$export$a4d69fb5f2026c35)(scrollLeft, start, end, true)) {
                t = i;
                break;
            }
        }
        steps[activeStep].classList.remove("is-active");
        activeStep = t;
        steps[activeStep].classList.add("is-active");
    }
    /**
   * @return {ScrollBehavior}
   */ function getScrollBehaviour() {
        let rootStyle = window.getComputedStyle(scrollRoot);
        if (!rootStyle.scrollBehavior) return "auto";
        return rootStyle.scrollBehavior;
    }
    /**
   * @param element
   * @param index
   * @return {ItemObject}
   */ function Item(element, index) {
        let rect = {
            size: 0,
            start: 0,
            end: 0
        };
        /** @type {ItemObject} item */ let item = {
            rect: rect,
            element: element,
            calculateRect: calculateRect,
            scrollTo: scrollTo,
            index: index
        };
        function calculateRect() {
            let { clientWidth: clientWidth, offsetLeft: offsetLeft } = element;
            rect.size = clientWidth;
            rect.start = offsetLeft;
            rect.end = offsetLeft + clientWidth;
        }
        function scrollTo() {
            scrollRoot.scrollTo({
                top: 0,
                left: rect.start,
                behavior: getScrollBehaviour()
            });
            currentItem = item;
            rootElement.dispatchEvent(new CustomEvent("slider:scroll-to"));
        }
        return item;
    }
}


/**
 * @param {HTMLElement} element
 */ function $da8a4b399816f51f$export$74a362b31437ec83(element) {
    const CLASS_READY = "is-ready";
    const CLASS_EXPANDED = "is-expanded";
    let isExpanded = element.classList.contains(CLASS_EXPANDED);
    let trigger = element.querySelector(".js-disclosure-trigger");
    let controls = trigger.dataset.controls;
    element.classList.add(CLASS_READY);
    trigger.addEventListener("click", handleClick);
    trigger.addEventListener("keydown", handleKeydown);
    trigger.removeAttribute("data-controls");
    trigger.setAttribute("aria-expanded", String(isExpanded));
    if (trigger) trigger.setAttribute("aria-controls", controls);
    element.classList.toggle(CLASS_EXPANDED, isExpanded);
    /**
   * @param {MouseEvent} event
   */ function handleClick(event) {
        toggle();
        event.preventDefault();
    }
    /**
   * @param {KeyboardEvent} event
   */ function handleKeydown(event) {
        switch(event.code){
            case "ArrowDown":
                open();
                event.preventDefault();
                break;
            case "ArrowUp":
                close();
                event.preventDefault();
                break;
            case "Space":
                toggle();
                event.preventDefault();
                break;
        }
    }
    function open() {
        isExpanded = true;
        element.classList.add(CLASS_EXPANDED);
        trigger.setAttribute("aria-expanded", "true");
    }
    function close() {
        isExpanded = false;
        element.classList.remove(CLASS_EXPANDED);
        trigger.setAttribute("aria-expanded", "false");
    }
    function toggle(toggle1 = !isExpanded) {
        return toggle1 ? open() : close();
    }
}


const $7ebc3fd2810ac05f$var$e = [
    "input",
    "select",
    "textarea",
    "button",
    "summary",
    "a[href]",
    "area[href]",
    "embed",
    "iframe",
    "object",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
];
function $7ebc3fd2810ac05f$var$t(e, t1 = !1) {
    "function" == typeof e.focus && e.focus({
        preventScroll: !t1
    });
}
function $7ebc3fd2810ac05f$var$n(e, n1 = !1) {
    const r = $7ebc3fd2810ac05f$var$o(e);
    if (!r.length) return !1;
    $7ebc3fd2810ac05f$var$t(r[0], n1);
}
function $7ebc3fd2810ac05f$var$o(t) {
    return Array.from(t.querySelectorAll($7ebc3fd2810ac05f$var$e.join(","))).filter((t)=>(function(t) {
            let n = parseInt(t.getAttribute("tabindex") || "", 10);
            if (t.hidden || n && n < 0 || t.matches(":disabled") || !t.matches($7ebc3fd2810ac05f$var$e.join(",")) || $7ebc3fd2810ac05f$var$r(t) && !function(e) {
                if (!$7ebc3fd2810ac05f$var$r(e)) return !1;
                let t = e.form || document;
                if (!Array.from(t.getElementsByName(e.name)).some((e)=>e.checked)) return !0;
                return e.checked;
            }(t) || !function(e) {
                if (0 === e.getClientRects().length) return !1;
                return "visible" === window.getComputedStyle(e).visibility;
            }(t)) return !1;
            return !0;
        })(t));
}
function $7ebc3fd2810ac05f$var$r(e) {
    return e instanceof HTMLInputElement && "radio" === e.type;
}
let $7ebc3fd2810ac05f$var$i, $7ebc3fd2810ac05f$var$a;
function $7ebc3fd2810ac05f$var$l(e) {
    let { currentTarget: t } = e;
    if (!(t instanceof HTMLElement && t.dataset.dialogOpen)) return;
    let n = $7ebc3fd2810ac05f$export$89b4be35062c4a3f(t.dataset.dialogOpen);
    n && (n.open(), e.preventDefault());
}
function $7ebc3fd2810ac05f$var$c(e) {
    let { currentTarget: t } = e;
    if (!(t instanceof HTMLElement && t.dataset.dialogClose)) return;
    let n = $7ebc3fd2810ac05f$export$89b4be35062c4a3f(t.dataset.dialogClose);
    n && (n.close(), e.preventDefault());
}
var $7ebc3fd2810ac05f$export$c9ace314e306b16d = Object.freeze({
    __proto__: null,
    get openers () {
        return $7ebc3fd2810ac05f$var$i;
    },
    get closers () {
        return $7ebc3fd2810ac05f$var$a;
    },
    mount: function() {
        $7ebc3fd2810ac05f$var$i = Array.from(document.querySelectorAll("[data-dialog-open]")), $7ebc3fd2810ac05f$var$a = Array.from(document.querySelectorAll("[data-dialog-close]")), $7ebc3fd2810ac05f$var$i.forEach((e)=>e.addEventListener("click", $7ebc3fd2810ac05f$var$l)), $7ebc3fd2810ac05f$var$a.forEach((e)=>e.addEventListener("click", $7ebc3fd2810ac05f$var$c));
    },
    unmount: function() {
        $7ebc3fd2810ac05f$var$i = [], $7ebc3fd2810ac05f$var$a = [], $7ebc3fd2810ac05f$var$i.forEach((e)=>e.removeEventListener("click", $7ebc3fd2810ac05f$var$l)), $7ebc3fd2810ac05f$var$a.forEach((e)=>e.removeEventListener("click", $7ebc3fd2810ac05f$var$c));
    }
});
const $7ebc3fd2810ac05f$var$d = {
    alert: !1,
    description: void 0,
    label: "Dialog",
    manageFocus: !0,
    openClass: "is-open"
}, $7ebc3fd2810ac05f$export$12d555061d854ced = {};
function $7ebc3fd2810ac05f$export$89b4be35062c4a3f(e) {
    return void 0 === e ? null : Object.prototype.hasOwnProperty.call($7ebc3fd2810ac05f$export$12d555061d854ced, e) ? $7ebc3fd2810ac05f$export$12d555061d854ced[e] : null;
}
function $7ebc3fd2810ac05f$export$518824cf31321346(e, r = {}) {
    let i, a = !1, l = !1, c = document.getElementById(e);
    if (!c) return;
    if ($7ebc3fd2810ac05f$export$12d555061d854ced.hasOwnProperty(e)) return $7ebc3fd2810ac05f$export$12d555061d854ced[e];
    const u = Object.assign({}, $7ebc3fd2810ac05f$var$d, r);
    function f(e) {
        "Escape" === e.key && v();
    }
    function m1(e, t = !0) {
        !a && l && b("open") && (a = !0, c.classList.add(u.openClass), document.addEventListener("keydown", f, !0), i && (void 0 === e && null !== c.querySelector("[data-dialog-autofocus]") && (e = c.querySelector("[data-dialog-autofocus]")), i.activate(e, t)));
    }
    function v(e, t = !0) {
        a && l && b("close") && (i && i.deactivate(e, t), a = !1, document.removeEventListener("keydown", f, !0), c.classList.remove(u.openClass));
    }
    function b(t) {
        let n = new CustomEvent("dialog:" + t, {
            bubbles: !0,
            cancelable: !0,
            detail: {
                id: e
            }
        });
        return c.dispatchEvent(n);
    }
    u.manageFocus && (i = function(e) {
        let r = !1, i = null, a = null;
        function l(o) {
            let r = o.target;
            if (e.contains(r)) return o.stopPropagation(), void (i = r);
            o.preventDefault(), i ? $7ebc3fd2810ac05f$var$t(i, !0) : $7ebc3fd2810ac05f$var$n(e, !0);
        }
        function c(n) {
            "Tab" !== n.key || n.altKey || n.ctrlKey || n.metaKey || function(e, n) {
                let r = document.activeElement, i = $7ebc3fd2810ac05f$var$o(e), a = i[0], l = i[i.length - 1];
                n.shiftKey && r == a ? ($7ebc3fd2810ac05f$var$t(l, !0), n.preventDefault()) : n.shiftKey || r != l || ($7ebc3fd2810ac05f$var$t(a, !0), n.preventDefault());
            }(e, n);
        }
        return {
            activated: r,
            activate: function(o, i = !1) {
                r || (a = document.activeElement, o ? $7ebc3fd2810ac05f$var$t(o, i) : null !== o && $7ebc3fd2810ac05f$var$n(e, i), document.addEventListener("focusin", l, !1), document.addEventListener("keydown", c, !1), r = !0);
            },
            deactivate: function(e, n = !1) {
                if (!r) return;
                document.removeEventListener("focusin", l, !1), document.removeEventListener("keydown", c, !1);
                let o = e || (null !== e ? a : null);
                o && $7ebc3fd2810ac05f$var$t(o, n), r = !1, i = null;
            }
        };
    }(c));
    const p = {
        close: v,
        create: function() {
            if (l) return !1;
            let e = u.alert ? "alertdialog" : "dialog";
            if (c.setAttribute("tabindex", "-1"), c.setAttribute("role", e), c.setAttribute("aria-modal", "true"), u.label) {
                let e = document.getElementById(u.label) ? "aria-labelledby" : "aria-label";
                c.setAttribute(e, u.label);
            }
            u.description && document.getElementById(u.description) && c.setAttribute("aria-describedby", u.description), l = !0, b("create");
        },
        destroy: function() {
            if (!l) return !1;
            v(), l = !1, [
                "role",
                "tabindex",
                "aria-modal",
                "aria-label",
                "aria-labelledby",
                "aria-describedby"
            ].forEach((e)=>c.removeAttribute(e)), b("destroy");
        },
        element: c,
        id: e,
        initiated: l,
        get isOpen () {
            return a;
        },
        off: function(e, t) {
            let n = "dialog:" + e;
            c.removeEventListener(n, t);
        },
        on: function(e, t) {
            let n = "dialog:" + e;
            c.addEventListener(n, t);
        },
        open: m1,
        toggle: function(e = !a) {
            e ? m1() : v();
        }
    };
    return $7ebc3fd2810ac05f$export$12d555061d854ced[e] = p;
}


let $e984e8713cdb8fc7$var$element = document.body;
let $e984e8713cdb8fc7$var$fixedElementSelector = ".c-cookie-notice";
function $e984e8713cdb8fc7$export$6a9f04c98a658ecb() {
    let width = $e984e8713cdb8fc7$var$getWidth();
    let computedStyle = window.getComputedStyle($e984e8713cdb8fc7$var$element);
    let paddingRight = parseInt(computedStyle.paddingRight, 10);
    $e984e8713cdb8fc7$var$element.style.overflow = "hidden";
    $e984e8713cdb8fc7$var$element.style.paddingRight = `${paddingRight + width}px`;
    Array.from(document.querySelectorAll($e984e8713cdb8fc7$var$fixedElementSelector)).forEach((element)=>{
        let computedStyle = window.getComputedStyle(element);
        element.setAttribute("data-right", element.style.right);
        let right = parseInt(computedStyle.right, 10);
        element.style.right = `${right + width}px`;
    });
}
function $e984e8713cdb8fc7$export$eccddd504975e05d() {
    $e984e8713cdb8fc7$var$element.removeAttribute("style");
    Array.from(document.querySelectorAll($e984e8713cdb8fc7$var$fixedElementSelector)).forEach(function(element) {
        element.style.right = element.getAttribute("data-right");
        element.removeAttribute("data-right");
    });
}
/**
 * @return {number}
 */ function $e984e8713cdb8fc7$var$getWidth() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    let documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


(0, $7ebc3fd2810ac05f$export$c9ace314e306b16d).mount();
function $eb437bbd6443c4c4$export$4071300121a182f5(element) {
    let dialogInstance = (0, $7ebc3fd2810ac05f$export$518824cf31321346)(element.id);
    if (dialogInstance === undefined) return;
    dialogInstance.create();
    let contents = element.querySelector(".js-drawer-contents");
    element.addEventListener("click", handleDrawerClick);
    /**
   * @param {MouseEvent} event
   */ function handleDrawerClick(event) {
        if (contents?.contains(event.target)) return;
        dialogInstance?.close();
    }
    dialogInstance.on("open", (0, $e984e8713cdb8fc7$export$6a9f04c98a658ecb));
    dialogInstance.on("close", (0, $e984e8713cdb8fc7$export$eccddd504975e05d));
}


const $48c2c3b7dbf5b89e$var$defaults = {
    root: null,
    rootMargin: "30%",
    threshold: 0,
    srcAttr: "data-src",
    srcsetAttr: "data-srcset",
    selector: "[data-src], [data-srcset]",
    onLoad: (element)=>element.classList.add("has-loaded"),
    onError: (element)=>element.classList.add("has-errored")
};
function $48c2c3b7dbf5b89e$export$e7975a21b41d4767(options = {}) {
    const config = {
        ...$48c2c3b7dbf5b89e$var$defaults,
        ...options
    };
    const intersectionObserver = new IntersectionObserver(onIntersection, {
        root: config.root,
        rootMargin: config.rootMargin,
        threshold: config.threshold
    });
    const resizeObserver = new ResizeObserver(onResize);
    const mutationObserver = new MutationObserver(onMutate);
    function onMutate() {
        getElements().forEach((elem)=>intersectionObserver.observe(elem));
    }
    /**
   * @param {ResizeObserverEntry[]} entries
   */ function onResize(entries) {
        for (let entry of entries){
            let width = $48c2c3b7dbf5b89e$var$getWidth(entry.target, entry.contentRect.width);
            $48c2c3b7dbf5b89e$var$setSizes(entry.target, `${width}px`);
        }
    }
    mutationObserver.observe(document, {
        childList: true,
        subtree: true,
        attributes: true
    });
    /** @type {Element[]} elements */ let elements = [];
    function getElements() {
        return Array.from(document.querySelectorAll(config.selector));
    }
    function update() {
        elements = getElements();
        elements.forEach((elem)=>{
            resizeObserver.observe(elem);
            intersectionObserver.observe(elem);
        });
    }
    /**
   * @param {IntersectionObserverEntry[]} entries
   */ function onIntersection(entries) {
        entries.filter((entry)=>entry.isIntersecting).map((entry)=>load(entry.target));
    }
    /**
   * @param {HTMLElement} element
   */ function setAttributes(element) {
        const { srcAttr: srcAttr, srcsetAttr: srcsetAttr } = config;
        const src = element.getAttribute(srcAttr);
        const srcset = element.getAttribute(srcsetAttr);
        if (srcset && element) {
            element.srcset = srcset;
            element.removeAttribute(srcsetAttr);
        }
        if (src) {
            element.src = src;
            element.removeAttribute(srcAttr);
        }
    }
    /**
   * @param {HTMLElement} element
   */ function load(element) {
        const index = elements.indexOf(element);
        element.onload = ()=>config.onLoad(element);
        element.onerror = ()=>config.onError(element);
        if (!element.getAttribute("sizes")) $48c2c3b7dbf5b89e$var$setSizes(element, `${$48c2c3b7dbf5b89e$var$getWidth(element, element.clientWidth)}px`);
        setAttributes(element);
        elements.splice(index, 1);
        intersectionObserver.unobserve(element);
    }
    return {
        update: update
    };
}
/**
 * @param {element} element
 * @param {number} width
 * @return {number}
 */ function $48c2c3b7dbf5b89e$var$getWidth(element, width) {
    let { parentNode: parentNode } = element;
    if (width >= 40 || parentNode === null) return width;
    return $48c2c3b7dbf5b89e$var$getWidth(parentNode);
}
/**
 * @param {Element} element
 * @param {string} sizes
 */ function $48c2c3b7dbf5b89e$var$setSizes(element, sizes) {
    let { parentNode: parentNode } = element;
    if (element instanceof HTMLImageElement) element.sizes = sizes;
    if (parentNode instanceof HTMLPictureElement) {
        let sources = Array.from(parentNode.querySelectorAll("source"));
        sources.forEach((source)=>{
            source.sizes = sizes;
        });
    }
}



function $b13b947bab7dffa6$export$214ae410b202e65a() {
    (0, $bf76b386537e82d7$export$dcd0d083aa86c355)(undefined, ".js-navigation-item").forEach((el)=>$b13b947bab7dffa6$var$NavigationItem(el));
}
/**
 * @param {HTMLElement} element
 */ function $b13b947bab7dffa6$var$NavigationItem(element) {
    let isOpen = false;
    let trigger = element.querySelector(".js-navigation-trigger");
    if (trigger === null) return;
    document.addEventListener("click", handleDocumentInteraction);
    document.addEventListener("focusin", handleDocumentInteraction);
    let button = (0, $bf76b386537e82d7$export$c8a8987d4410bf2d)("button", {
        type: "button",
        class: trigger.className,
        "aria-expanded": String(isOpen),
        "aria-controls": trigger.dataset.controls
    });
    button.innerHTML = trigger.innerHTML;
    trigger.insertAdjacentElement("afterend", button);
    trigger.remove();
    button.addEventListener("click", ()=>toggle());
    function toggle(toggle1 = !isOpen) {
        toggle1 ? open() : close();
    }
    function open() {
        isOpen = true;
        button.setAttribute("aria-expanded", "true");
        element.classList.add("is-expanded");
    }
    function close() {
        isOpen = false;
        element.classList.remove("is-expanded");
        button.setAttribute("aria-expanded", "false");
    }
    /**
   * @param {FocusEvent|MouseEvent} event
   */ function handleDocumentInteraction(event) {
        /** @type {HTMLElement} event.target */ if (element.contains(event.target)) return;
        close();
    }
}





const $7e6c34e24017c914$var$PAUSED_CLASS = "is-paused";
const $7e6c34e24017c914$var$PLAYING_CLASS = "is-playing";
function $7e6c34e24017c914$export$fbed5f62d839a0cd(element) {
    if (!(element instanceof HTMLButtonElement)) return;
    let video = document.getElementById(element.dataset.target);
    element.classList.remove("hidden");
    element.addEventListener("click", togglePlay);
    video.addEventListener("click", togglePlay);
    video.addEventListener("play", checkStatus);
    video.addEventListener("pause", checkStatus);
    checkStatus();
    function checkStatus() {
        let playing = !video.paused;
        element.classList.toggle($7e6c34e24017c914$var$PAUSED_CLASS, !playing);
        element.classList.toggle($7e6c34e24017c914$var$PLAYING_CLASS, playing);
        element.innerHTML = playing ? (0, {}) : (0, {});
        let label = (0, $bf76b386537e82d7$export$c8a8987d4410bf2d)("span", {
            class: "visually-hidden"
        });
        label.textContent = playing ? "Pause" : "Play";
        element.append(label);
    }
    async function togglePlay() {
        if (!video.paused) {
            video?.pause();
            return;
        }
        try {
            await video.play();
        } catch (error) {
        // no catch
        }
    }
}


/**
 * @param {HTMLElement} element
 */ function $057b6001bc37b2ce$export$ae01dedf5c052bb(element) {
    let embedCode = element.dataset.videoEmbedCode;
    if (embedCode) element.addEventListener("click", onClick);
    function onClick() {
        element.removeEventListener("click", onClick);
        let embedTarget = element.querySelector('[data-video-target="embed"]');
        if (!embedTarget) return;
        element.addEventListener("load", ()=>console.log("load"));
        embedTarget.innerHTML = embedCode || "";
    }
}


/**
 * -----------------------------------------------------------------------------
 * Blocking
 * -----------------------------------------------------------------------------
 *
 * In order to defer the loading and execution of an element use the
 * data-cookie-consent attribute.
 *
 * For inline scripts the type needs to be set to text/plain.
 *
 * <script data-cookie-consent type="text/plain">
 * 	// script contents
 * </script>
 *
 * For external scrips and iframes etc. set the data-cookie-consent value to
 * the url of the resource.
 *
 * <script data-cookie-consent="https://www.exmaple.com/script.js">
 * <iframe data-cookie-consent="https://www.exmaple.com/script.js"></iframe>
 *
 * -----------------------------------------------------------------------------
 * Consent management
 * -----------------------------------------------------------------------------
 *
 * Consent can be managed in two ways, using a button with the value set to
 * 0 or 1 or using a form with radio buttons whose values are set to 0 or 1.
 *
 * <button class="js-cookie-consent-button" type="button" value="1">Allow</button>
 * <button class="js-cookie-consent-button" type="button" value="0">Disallow</button>
 *
 * <form class="js-cookie-consent-form">
 *	  <input id="cookie-consent-allow" type="radio" name="cookie-preference" value="1">
 *	  <label for="cookie-consent-allow">Allow</label>
 *
 * 	  <input id="cookie-consent-disallow" type="radio" name="cookie-preference" value="0">
 * 	  <label for="cookie-consent-disallow">Disallow</label>
 *
 * 	  <button>Save</button>
 *	</form>
 */ 
/**
 * @param {string} name
 * @param {HTMLFormElement} form
 * @return {string[]|string|*}
 */ function $7a28ff65e032bccb$export$c5e4b84d2ce61726(name, form) {
    let value;
    let field = form.elements[name];
    if (field === undefined) return value;
    if ($7a28ff65e032bccb$var$isRadioNodeListLike(field)) {
        let elements = Array.from(field);
        let isRadioGroup = elements.every((el)=>el.type === "radio");
        let values = elements.filter((el)=>el.checked).map((el)=>el.value);
        if (!isRadioGroup) value = values;
        else value = values.length ? values[0] : "";
        return value;
    }
    if (field instanceof HTMLSelectElement) {
        let options = Array.from(field.options);
        let isSingleSelect = field.type === "select-one";
        if (isSingleSelect) value = options[field.selectedIndex].value;
        else value = options.filter((opt)=>opt.selected).map((opt)=>opt.value);
        return value;
    }
    if (field instanceof HTMLInputElement) {
        if (field.type === "checkbox") value = field.checked ? field.value : "";
        else value = field.value;
        return value;
    }
    return value;
}
/**
 * Check a value to see if it's an object representing a collection of checkbox or
 * radio elements. Most browsers correctly report RadioNodeList for both however
 * IE returns a HTMLCollection despite supporting RadioNodeList.
 *
 * @param {*} element
 * @return {boolean}
 */ function $7a28ff65e032bccb$var$isRadioNodeListLike(element) {
    return element instanceof HTMLCollection || typeof RadioNodeList !== "undefined" && element instanceof RadioNodeList;
}


/** @type {boolean} */ let $149628f3b381e2b3$var$consented;
let $149628f3b381e2b3$var$cookieName = "cookie-consent";
let $149628f3b381e2b3$var$attributeName = "data-cookie-consent";
let $149628f3b381e2b3$var$formInputName = "cookie-preference";
function $149628f3b381e2b3$export$2cd8252107eb640b() {
    $149628f3b381e2b3$var$consented = $149628f3b381e2b3$var$getConsentSettings();
    if ($149628f3b381e2b3$var$consented) $149628f3b381e2b3$var$loadAll();
    Array.from(document.querySelectorAll("form.js-cookie-consent-form")).forEach((form)=>$149628f3b381e2b3$var$Form(form));
    Array.from(document.querySelectorAll("button.js-cookie-consent-button")).forEach((button)=>$149628f3b381e2b3$var$Button(button));
}
function $149628f3b381e2b3$var$getConsentSettings() {
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).get($149628f3b381e2b3$var$cookieName);
    if (value === undefined) return undefined;
    return JSON.parse(value);
}
/**
 * @param {boolean} value
 * @param {boolean} load
 */ function $149628f3b381e2b3$var$setConsent(value, load = true) {
    $149628f3b381e2b3$var$Notice().hide();
    (0, (/*@__PURE__*/$parcel$interopDefault($39b3979787198c97$exports))).set($149628f3b381e2b3$var$cookieName, JSON.stringify(value), {
        expires: 365,
        sameSite: "strict"
    });
    if (value && load) $149628f3b381e2b3$var$loadAll();
}
function $149628f3b381e2b3$var$getElements() {
    return Array.from(document.querySelectorAll(`[${$149628f3b381e2b3$var$attributeName}]`));
}
/**
 * @param {Element|Element[]} element
 */ function $149628f3b381e2b3$var$load(element) {
    if (Array.isArray(element)) {
        element.forEach((element)=>$149628f3b381e2b3$var$load(element));
        return;
    }
    let attributeValue = element.getAttribute($149628f3b381e2b3$var$attributeName);
    if ($149628f3b381e2b3$var$isInlineScript(element)) $149628f3b381e2b3$var$loadInlineScript(element);
    else if (attributeValue) {
        element.removeAttribute($149628f3b381e2b3$var$attributeName);
        element.setAttribute("src", attributeValue);
    }
}
function $149628f3b381e2b3$var$loadAll() {
    $149628f3b381e2b3$var$load($149628f3b381e2b3$var$getElements());
}
/**
 * @param {Element} element
 */ function $149628f3b381e2b3$var$isInlineScript(element) {
    let attributeValue = element.getAttribute($149628f3b381e2b3$var$attributeName);
    return element instanceof HTMLScriptElement && !attributeValue;
}
/**
 * @param {HTMLScriptElement} script
 */ function $149628f3b381e2b3$var$loadInlineScript(script) {
    /** @type {HTMLScriptElement} clone */ let clone = script.cloneNode(true);
    clone.setAttribute("type", "text/javascript");
    clone.removeAttribute($149628f3b381e2b3$var$attributeName);
    script.after(clone);
    script.remove();
}
function $149628f3b381e2b3$var$Notice() {
    let element = document.querySelector(".js-cookie-notice");
    function hide() {
        element.style.display = "none";
    }
    function show() {
        element.style.display = "block";
    }
    return {
        show: show,
        hide: hide
    };
}
/**
 * @param {HTMLButtonElement} element
 */ function $149628f3b381e2b3$var$Button(element) {
    element.addEventListener("click", onClick);
    /**
   * @param {MouseEvent} event
   */ function onClick(event) {
        /** @type {HTMLButtonElement} */ let target = event.currentTarget;
        $149628f3b381e2b3$var$setConsent(!!Number(target.value));
    }
}
/**
 * @param {HTMLFormElement} element
 */ function $149628f3b381e2b3$var$Form(element) {
    element.addEventListener("submit", onSubmit);
    /**
   * @param {SubmitEvent} event
   */ function onSubmit(event) {
        let value = Number((0, $7a28ff65e032bccb$export$c5e4b84d2ce61726)($149628f3b381e2b3$var$formInputName, element));
        $149628f3b381e2b3$var$setConsent(!!value, false);
        event.preventDefault();
    }
}


let $5a3fc3e2587399e4$var$app = (0, $0680554f6bbebb99$export$86fbec116b87613f)();
(0, $149628f3b381e2b3$export$2cd8252107eb640b)();
let $5a3fc3e2587399e4$var$lazyLoader = (0, $48c2c3b7dbf5b89e$export$e7975a21b41d4767)();
$5a3fc3e2587399e4$var$lazyLoader.update();
$5a3fc3e2587399e4$var$app.start();
$5a3fc3e2587399e4$var$app.register("drawer", (0, $eb437bbd6443c4c4$export$4071300121a182f5));
$5a3fc3e2587399e4$var$app.register("disclosure", (0, $da8a4b399816f51f$export$74a362b31437ec83));
$5a3fc3e2587399e4$var$app.register("alert", (0, $14e72c11e5d59e2b$export$caec2af78bcc877f));
$5a3fc3e2587399e4$var$app.register("navigation-bar", (0, $b13b947bab7dffa6$export$214ae410b202e65a));
$5a3fc3e2587399e4$var$app.register("video", (0, $057b6001bc37b2ce$export$ae01dedf5c052bb));
$5a3fc3e2587399e4$var$app.register("carousel", (0, $e18e62e0f1712f3a$export$144901db2ea8e967));
$5a3fc3e2587399e4$var$app.register("autoplay", (0, $3cfeed1fccbdf967$export$6c96167f46662e38));
$5a3fc3e2587399e4$var$app.register("play-button", (0, $7e6c34e24017c914$export$fbed5f62d839a0cd));
const $5a3fc3e2587399e4$var$accordionButtons = document.querySelectorAll(".accordion-button");
$5a3fc3e2587399e4$var$accordionButtons.forEach((button)=>{
    button.addEventListener("click", ()=>{
        const item = button.parentElement;
        const isExpanded = item.classList.contains("is-expanded");
        // Toggle the clicked item
        if (!isExpanded) item.classList.add("is-expanded");
        else item.classList.remove("is-expanded");
    });
});

})();
//# sourceMappingURL=main.js.map
